module.exports = __webpack_public_path__ + "assets/ed2e8a183bbb219fc5b411e581d0153b.png";